interface GodModeToggleProps {
  isRoomGodMode: boolean;
  onToggle: () => void;
}

/** God mode toggle - admin only, gives owner-level rights in this room. */
export default function GodModeToggle({ isRoomGodMode, onToggle }: GodModeToggleProps) {
  return (
    <div
      onClick={onToggle}
      style={{
        position: 'absolute',
        top: 116,
        right: 16,
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
        padding: '6px 24px',
        borderRadius: '50px',
        background: 'rgba(219, 219, 219, 0.3)',
        boxShadow: 'inset 4px 3px 5.9px 0px rgba(0, 0, 0, 0.12)',
        cursor: 'pointer',
        pointerEvents: 'auto',
      }}
    >
      <div
        style={{
          color: '#FFF',
          textAlign: 'center',
          WebkitTextStrokeWidth: '1.21px',
          WebkitTextStrokeColor: 'rgba(0, 0, 0, 0.60)',
          fontFamily: '"Rubik One", sans-serif',
          fontSize: '16px',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: '29px',
          letterSpacing: '-0.747px',
          whiteSpace: 'nowrap',
        }}
      >
        God
      </div>
      <div
        style={{
          position: 'relative',
          width: '39px',
          height: '24px',
          borderRadius: '100px',
          background: isRoomGodMode ? '#6750A4' : 'rgba(219, 219, 219, 0.5)',
          padding: '1.5px 3px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: isRoomGodMode ? 'flex-end' : 'flex-start',
          transition: 'all 0.2s ease',
        }}
      >
        <div
          style={{
            width: '21px',
            height: '21px',
            borderRadius: '24px',
            background: '#FFFFFF',
            boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.3)',
            transition: 'all 0.2s ease',
          }}
        />
      </div>
    </div>
  );
}
